import { useEffect, useMemo } from 'react'
import { Flex } from '@mantine/core'

import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import type { AgeSummaryProps } from '@/components/@Shared/UserManagmentCharts/AgeSummary/AgeSummary.types'
import { Loader } from '@/components/Loader/Loader'
import { RangeBarChart } from '@/components/RangeBarChart/RangeBarChart'
import { Title } from '@/components/Title/Title'

import { AGE_RANGES } from '@/constants/chartData.constants'

import { calculateRanges } from '@/helpers/calculateRanges.helper'
import { getStats } from '@/helpers/chartData.helper'

export function AgeSummary({
  data,
  isLoading,
  onUpdateChartsData,
}: AgeSummaryProps) {
  const ageRangeCounts = useMemo(() => {
    const stats = getStats(data)

    return calculateRanges(stats, AGE_RANGES)
  }, [data])

  useEffect(() => {
    if (!onUpdateChartsData) return

    onUpdateChartsData(ageRangeCounts, 'age')
  }, [ageRangeCounts, onUpdateChartsData])

  return (
    <ShadowBox w={{ base: '100%', lg: '50%' }}>
      <Title variant="h2">Age</Title>

      {isLoading ? (
        <Flex h="calc(100% - 42px)">
          <Loader isMinimized />
        </Flex>
      ) : (
        <RangeBarChart
          color="var(--mantine-other-colors-green)"
          sections={ageRangeCounts}
        />
      )}
    </ShadowBox>
  )
}
